/**
 * Hier werden alle Änderungen (Mutations) des Stores definiert
 */

export const SET_ADRESSE = 'setAdresse'
export const SET_IDS = 'setIds'
export const SET_ADRESSMELDUNG = 'setAdressmeldung'
export const SET_ADRESSDATEN = 'setAdressdaten'
export const SET_LANGUAGE = 'setLanguage'
